import { cn } from '@/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

const badgeVariants = cva(
  'inline-flex items-center px-2.5 py-0.5 rounded-md text-xs bg-opacity-10 font-semibold',
  {
    variants: {
      variant: {
        default:
          'border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80',
        warning: 'bg-warning text-warning-600 border border-warning-500',
        success: 'bg-success/20 text-success ',
        destructive:
          'border-transparent bg-destructive/20 text-destructive shadow hover:bg-destructive/80',
        secondary:
          'bg-secondary hover:bg-secondary/80 border-transparent text-secondary-foreground',
        outline: 'bg-transparent text border border-foreground-muted',
      },
      size: {
        small: 'px-2.5 py-0.5 text-xs',
        large: 'px-3 py-0.5 rounded-md text-sm',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'small',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({
  className,
  variant = 'default',
  size,
  children,
  ...props
}: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant, size }), className)} {...props}>
      {children}
    </div>
  );
}

export { Badge, badgeVariants };
